/* CONTRASTE · interacciones y movimiento — Guilartech v5 */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var touch = window.matchMedia && window.matchMedia('(hover: none)').matches;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- 0. entrada de página ---------- */
  function ready() { requestAnimationFrame(function () { document.body.classList.add('ready'); }); }

  /* ---------- 1. partir el texto en palabras ---------- */
  function splitText() {
    if (reduce) return;
    $$('[data-split]').forEach(function (el) {
      if (el.dataset.splitDone) return;
      var walk = function (node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (n) {
          if (n.nodeType === 3) {
            var frag = document.createDocumentFragment();
            n.textContent.split(/(\s+)/).forEach(function (part) {
              if (!part.trim()) { frag.appendChild(document.createTextNode(part)); return; }
              var w = document.createElement('span'); w.className = 'w';
              var i = document.createElement('i'); i.textContent = part;
              w.appendChild(i); frag.appendChild(w);
            });
            n.parentNode.replaceChild(frag, n);
          } else if (n.nodeType === 1 && !n.classList.contains('w')) {
            walk(n);
          }
        });
      };
      el.classList.add('split');
      walk(el);
      $$('.w > i', el).forEach(function (i, k) { i.style.setProperty('--wi', k); });
      el.dataset.splitDone = '1';
    });
  }

  /* ---------- 2. revelado al hacer scroll ---------- */
  function reveal() {
    var els = $$('[data-anim], [data-split]');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('in');
        io.unobserve(e.target);
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function stagger() {
    $$('[data-stagger]').forEach(function (parent) {
      Array.prototype.slice.call(parent.children).forEach(function (child, i) {
        if (!child.hasAttribute('data-anim')) child.setAttribute('data-anim', '');
        child.style.setProperty('--i', i % 8);
      });
    });
  }

  function prepDraw() {
    $$('.draw').forEach(function (p) {
      try { p.style.setProperty('--len', Math.ceil(p.getTotalLength())); } catch (e) {}
    });
  }

  /* ---------- 3. parallax al hacer scroll (sin leer layout en cada cuadro) ---------- */
  function parallax() {
    var els = $$('[data-parallax]');
    if (!els.length || reduce) return;
    if (document.body.hasAttribute('data-noparallax')) return;
    /* si el navegador soporta animation-timeline, el CSS ya lo hace fuera del hilo principal */
    if (window.CSS && CSS.supports && CSS.supports('animation-timeline', 'view()')) return;

    var cache = [], ticking = false;
    function measure() {
      cache = els.map(function (el) {
        var r = el.getBoundingClientRect();
        return { el: el, top: r.top + window.scrollY, h: r.height,
                 sp: parseFloat(el.getAttribute('data-parallax')) || 0.12 };
      });
      els.forEach(function (el) { el.style.willChange = 'transform'; });
    }
    function frame() {
      var y = window.scrollY, vh = window.innerHeight;
      for (var i = 0; i < cache.length; i++) {
        var c = cache[i];
        var mid = c.top + c.h / 2 - y - vh / 2;
        if (mid < -vh - 300 || mid > vh + 300) continue;
        c.el.style.transform = 'translate3d(0,' + (-mid * c.sp).toFixed(1) + 'px,0)';
      }
      ticking = false;
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    measure(); frame();
    window.addEventListener('scroll', onScroll, { passive: true });
    var rt; window.addEventListener('resize', function () {
      clearTimeout(rt); rt = setTimeout(function () { measure(); frame(); }, 180);
    }, { passive: true });
  }

  /* ---------- 4. parallax con el puntero en el collage ---------- */
  function pointerArt() {
    var art = $('.hero__art');
    if (!art || reduce || touch) return;
    if (document.body.hasAttribute('data-nopointer')) return;
    var groups = $$('.collage__l', art);
    if (!groups.length) return;
    var tx = 0, ty = 0, cx = 0, cy = 0, raf = null;
    function loop() {
      cx += (tx - cx) * 0.06; cy += (ty - cy) * 0.06;
      groups.forEach(function (g, i) {
        var d = (i + 1) * 7;
        g.style.setProperty('--px', (cx * d).toFixed(1) + 'px');
        g.style.setProperty('--py', (cy * d).toFixed(1) + 'px');
      });
      if (Math.abs(tx - cx) > 0.001 || Math.abs(ty - cy) > 0.001) raf = requestAnimationFrame(loop);
      else raf = null;
    }
    var hero = $('.hero') || art;
    hero.addEventListener('mousemove', function (e) {
      var r = hero.getBoundingClientRect();
      tx = (e.clientX - r.left) / r.width - 0.5;
      ty = (e.clientY - r.top) / r.height - 0.5;
      if (!raf) raf = requestAnimationFrame(loop);
    }, { passive: true });
    hero.addEventListener('mouseleave', function () {
      tx = 0; ty = 0; if (!raf) raf = requestAnimationFrame(loop);
    });
  }

  /* ---------- 5. header ---------- */
  function stickyHeader() {
    var hd = $('.hd'); if (!hd) return;
    var on = false;
    function check() { var s = window.scrollY > 16; if (s !== on) { on = s; hd.classList.toggle('scrolled', s); } }
    check(); window.addEventListener('scroll', check, { passive: true });
  }

  /* ---------- 6. menú móvil ---------- */
  function mobileNav() {
    var nav = $('.mnav'), open = $('[data-mnav-open]'), close = $('[data-mnav-close]');
    if (!nav || !open) return;
    var last = null;
    function show() {
      last = document.activeElement;
      nav.classList.add('open'); nav.setAttribute('aria-hidden', 'false');
      open.setAttribute('aria-expanded', 'true');
      document.body.classList.add('locked');
      var f = nav.querySelector('a, button'); if (f) f.focus();
    }
    function hide() {
      nav.classList.remove('open'); nav.setAttribute('aria-hidden', 'true');
      open.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('locked'); if (last) last.focus();
    }
    open.addEventListener('click', show);
    if (close) close.addEventListener('click', hide);
    nav.addEventListener('click', function (e) { if (e.target.tagName === 'A') hide(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && nav.classList.contains('open')) hide(); });
  }

  /* ---------- 7. carrusel del hero ---------- */
  function heroCarousel() {
    var root = $('[data-carousel]'); if (!root) return;
    var slides = $$('.hero__slide', root), dots = $$('.hero__dots button', root);
    var cur = $('[data-carousel-current]', root);
    if (slides.length < 2) { var d = $('.hero__dots', root); if (d) d.style.display = 'none'; return; }
    var i = 0, timer = null, delay = parseInt(root.getAttribute('data-carousel'), 10) || 6000;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        s.classList.toggle('on', k === i);
        if (k === i) { s.querySelectorAll('[data-split]').forEach(function (t) { t.classList.remove('in'); void t.offsetWidth; t.classList.add('in'); }); }
      });
      dots.forEach(function (dd, k) { dd.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (cur) cur.textContent = ('0' + (i + 1)).slice(-2);
    }
    function start() { if (!reduce) { stop(); timer = setInterval(function () { go(i + 1); }, delay); } }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    dots.forEach(function (dd, k) { dd.addEventListener('click', function () { go(k); start(); }); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 42) go(i + (dx < 0 ? 1 : -1));
      x0 = null; start();
    }, { passive: true });
    go(0); start();
  }

  /* ---------- 8. videos: solo se reproducen cuando se ven ---------- */
  function videos() {
    var vids = $$('video[data-auto]');
    if (!vids.length) return;
    vids.forEach(function (v) { v.muted = true; v.setAttribute('playsinline', ''); });
    if (!('IntersectionObserver' in window)) { vids.forEach(function (v) { v.play().catch(function () {}); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { v.play().catch(function () {}); }
        else { v.pause(); }
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { io.observe(v); });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) vids.forEach(function (v) { v.pause(); });
    });
  }


  /* ---------- 8b. arrastrar la franja de video con el mouse ----------
     Con el dedo el navegador ya lo hace solo; esto es para escritorio.
     Se cancela el clic si hubo arrastre real, para no abrir enlaces sin querer. */
  function arrastrarPista() {
    $$('[data-arrastre]').forEach(function (pista) {
      var abajo = false, xIni = 0, scrollIni = 0, movido = 0;
      pista.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        abajo = true; movido = 0;
        xIni = e.clientX; scrollIni = pista.scrollLeft;
        pista.setAttribute('data-arrastrando', '');
      });
      pista.addEventListener('pointermove', function (e) {
        if (!abajo) return;
        var d = e.clientX - xIni;
        movido = Math.max(movido, Math.abs(d));
        pista.scrollLeft = scrollIni - d;
      });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
        pista.addEventListener(ev, function () {
          abajo = false; pista.removeAttribute('data-arrastrando');
        });
      });
      pista.addEventListener('click', function (e) {
        if (movido > 6) { e.preventDefault(); e.stopPropagation(); }
      }, true);
    });
  }

  /* video al pasar el mouse en las tarjetas de producto */
  function cardVideos() {
    if (touch) return;
    $$('.pcard').forEach(function (card) {
      var v = card.querySelector('video[data-hover]');
      if (!v) return;
      v.muted = true; v.loop = true; v.setAttribute('playsinline', '');
      card.addEventListener('mouseenter', function () { v.play().catch(function () {}); });
      card.addEventListener('mouseleave', function () { v.pause(); v.currentTime = 0; });
    });
  }

  /* ---------- 9. galería de producto (imagen + video) ---------- */
  function gallery() {
    var root = $('[data-gallery]'); if (!root) return;
    var stage = $('[data-gallery-stage]', root);
    var thumbs = $$('[data-gallery-thumb]', root);
    if (!stage || !thumbs.length) return;
    function show(t) {
      var kind = t.getAttribute('data-kind');
      var src = t.getAttribute('data-full');
      if (kind === 'video') {
        stage.innerHTML = '<video data-gallery-main playsinline muted loop controls preload="metadata" poster="' + (t.getAttribute('data-poster') || '') + '"><source src="' + src + '" type="video/mp4"></video>';
        var v = stage.querySelector('video'); if (v) v.play().catch(function () {});
      } else if (kind === 'external') {
        stage.innerHTML = '<iframe src="' + src + '" title="Video del producto" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>';
      } else {
        stage.innerHTML = '<img data-gallery-main src="' + src + '" alt="' + (t.getAttribute('data-alt') || '') + '">';
      }
      thumbs.forEach(function (o) { o.setAttribute('aria-current', 'false'); });
      t.setAttribute('aria-current', 'true');
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(t); }); });
  }

  /* ---------- 10. selector de variantes ---------- */
  function variants() {
    var root = $('[data-variants]'); if (!root) return;
    var holder = $('[data-variant-json]', root); if (!holder) return;
    var data; try { data = JSON.parse(holder.textContent); } catch (e) { return; }

    var idInput = $('[data-variant-id]', root),
        priceEl = $('[data-variant-price]', root),
        wasEl = $('[data-variant-was]', root),
        btn = $('[data-add]', root),
        stockEl = $('[data-variant-stock]', root),
        stage = $('[data-gallery-stage]'),
        money = root.getAttribute('data-money') || '${{amount}}';

    function fmt(cents) {
      var n = (cents / 100).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return money.replace(/\{\{\s*amount\s*\}\}/, n)
                  .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toLocaleString('es-MX'))
                  .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n);
    }
    function chosen() {
      return $$('[data-opt]', root).map(function (g) { var c = g.querySelector('input:checked'); return c ? c.value : null; });
    }
    function match(sel) {
      return data.filter(function (v) { return sel.every(function (val, i) { return val === null || v.options[i] === val; }); });
    }
    function paint() {
      var sel = chosen();
      $$('[data-opt]', root).forEach(function (g, gi) {
        $$('input', g).forEach(function (inp) {
          var probe = sel.slice(); probe[gi] = inp.value;
          var can = match(probe).some(function (v) { return v.available; });
          var lab = g.querySelector('label[for="' + inp.id + '"]');
          if (lab) lab.classList.toggle('soldout', !can);
        });
      });
    }
    function update() {
      var v = match(chosen())[0];
      $$('[data-opt]', root).forEach(function (g) {
        var c = g.querySelector('input:checked'), out = g.querySelector('.val');
        if (out && c) out.textContent = c.value;
      });
      paint();
      if (!v) { if (btn) { btn.disabled = true; btn.textContent = 'No disponible'; } return; }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = fmt(v.price);
      if (wasEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) { wasEl.textContent = fmt(v.compare_at_price); wasEl.hidden = false; }
        else wasEl.hidden = true;
      }
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? btn.getAttribute('data-label') : 'Agotado'; }
      if (stockEl) {
        if (!v.available) { stockEl.textContent = 'Agotado'; stockEl.classList.add('low'); }
        else if (v.policy === 'deny' && v.qty > 0 && v.qty <= 3) { stockEl.textContent = 'Últimas ' + v.qty + ' piezas'; stockEl.classList.add('low'); }
        else { stockEl.textContent = 'Disponible'; stockEl.classList.remove('low'); }
      }
      if (stage && v.image) stage.innerHTML = '<img data-gallery-main src="' + v.image + '" alt="">';
      if (history.replaceState) {
        try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); } catch (e) {}
      }
    }
    $$('[data-opt] input', root).forEach(function (inp) { inp.addEventListener('change', update); });
    update();
  }

  /* ---------- 11. cantidad ---------- */
  function qty() {
    $$('.qty').forEach(function (box) {
      var input = box.querySelector('input');
      box.addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b || !input) return;
        e.preventDefault();
        var step = b.getAttribute('data-step') === '-' ? -1 : 1;
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + step);
      });
    });
  }

  /* ---------- 12. cinta: duplica el contenido para el bucle ---------- */
  function marquee() {
    $$('.marq__track').forEach(function (t) {
      if (t.dataset.dup) return;
      t.appendChild(t.firstElementChild.cloneNode(true));
      t.dataset.dup = '1';
    });
  }

  function init() {
    splitText(); stagger(); prepDraw(); reveal();
    stickyHeader(); mobileNav(); heroCarousel();
    marquee(); parallax(); pointerArt();
    videos(); arrastrarPista(); cardVideos(); gallery(); variants(); qty();
    ready();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Loop de fondo: reproducción automática infinita, a prueba de las políticas
   de autoplay. muted/playsInline por propiedad (Safari ignora el atributo a
   veces), reintento en cada evento de carga, y si aun así se bloquea, el
   primer gesto de la persona lo arranca. Solo se detiene con reduced-motion. */
(function () {
  var v = document.getElementById('loopHero');
  if (!v) return;
  var q = window.matchMedia('(prefers-reduced-motion: reduce)');
  v.muted = true; v.defaultMuted = true; v.playsInline = true; v.loop = true;
  var listo = false;
  function arrancar() {
    if (q.matches) { v.pause(); return; }
    var p = v.play();
    if (p && p.then) p.then(function () { listo = true; }).catch(function () {});
  }
  ['loadedmetadata','loadeddata','canplay','canplaythrough'].forEach(function (e) { v.addEventListener(e, arrancar); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) arrancar(); });
  v.addEventListener('pause', function () { if (!q.matches && !document.hidden) setTimeout(arrancar, 120); });
  v.addEventListener('ended', arrancar);
  q.addEventListener('change', arrancar);
  arrancar();
  setTimeout(function () {
    if (q.matches) return;
    if (v.paused || v.currentTime === 0) {
      var capa = v.parentNode;
      if (capa) {
        capa.style.setProperty('--poster', 'url("' + v.getAttribute('poster') + '")');
        capa.className += ' fondo--sinvideo';
      }
    }
  }, 2500);
  var gestos = ['pointerdown','touchstart','scroll','keydown','mousemove'];
  function gesto() {
    var capa = v.parentNode;
    if (capa && capa.className.indexOf('fondo--sinvideo') > -1)
      capa.className = capa.className.replace(' fondo--sinvideo', '');
    arrancar(); if (listo) gestos.forEach(function (e) { window.removeEventListener(e, gesto); }); }
  gestos.forEach(function (e) { window.addEventListener(e, gesto, { passive: true }); });
})();

/* La paleta filtra el catálogo por color. Cada tarjeta de producto lleva sus
   colores en data-colores; las muestras sin piezas se apagan solas. */
(function () {
  var muestras = [].slice.call(document.querySelectorAll('.pal__btn'));
  var tarjetas = [].slice.call(document.querySelectorAll('[data-colores]'));
  if (!muestras.length || !tarjetas.length) return;
  var activo = null;
  function cuenta(color) {
    var n = 0;
    tarjetas.forEach(function (t) {
      if ((t.getAttribute('data-colores') || '').split('|').indexOf(color) > -1) n++;
    });
    return n;
  }
  muestras.forEach(function (m) {
    var c = m.getAttribute('data-color');
    var n = cuenta(c);
    var et = m.querySelector('.pal__conteo');
    if (et) et.textContent = n + (n === 1 ? ' pieza' : ' piezas');
    if (!n) { m.disabled = true; m.setAttribute('aria-disabled', 'true'); return; }
    m.addEventListener('click', function () {
      activo = (activo === c) ? null : c;
      tarjetas.forEach(function (t) {
        var suyos = (t.getAttribute('data-colores') || '').split('|');
        t.hidden = !!activo && suyos.indexOf(activo) === -1;
      });
      muestras.forEach(function (o) {
        o.setAttribute('aria-pressed', String(o.getAttribute('data-color') === activo));
      });
      var destino = document.querySelector('#coleccion, .coleccion, main');
      if (destino && activo) destino.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
})();
